import { connect } from 'react-redux'

import LeaseeJoin from 'app/bond_cover/renters/tenants/leasee_join'

export default connect()(LeaseeJoin)
